import { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TmdxSelect } from '@ds';
import { AdminFormRow } from '@ui';
import { Employee } from '@/api/apis/resources';
import { renderAutocompleteItem } from '@/utils/helpers';
import { employeeMapper } from '../../utils';
import { EditRegionFormType } from '../types';

const renderManagersDropdownValue = (itemList: Employee[] = []) => (
  <div className="flex gap-2 flex-wrap">{itemList.map((m) => employeeMapper(m).name).join(', ')}</div>
);

type RegionManagerSelectProps = {
  name: 'regionalManagers' | 'nationalManagers';
  label: string;
  isReadOnly?: boolean;
};

export const RegionManagerSelect = memo(({ name, label, isReadOnly }: RegionManagerSelectProps) => {
  const { control } = useFormContext<EditRegionFormType>();

  return (
    <AdminFormRow title={label} isRequired={!isReadOnly}>
      <Controller
        name={name}
        control={control}
        render={({ field: { value }, fieldState: { invalid, error } }) => (
          <TmdxSelect
            isMultiline
            selectionMode="multiple"
            placeholder="Choose an option"
            aria-label={label}
            isDisabled
            isInvalid={invalid}
            errorMessage={error?.message}
            items={value || []}
            selectedKeys={value?.map((m) => m.id) || []}
            renderValue={() => renderManagersDropdownValue(value || [])}
          >
            {renderAutocompleteItem}
          </TmdxSelect>
        )}
      />
    </AdminFormRow>
  );
});
